import { useEffect, useState } from 'react';
import { Col, Card, CardBody, CardHeader, CardFooter, Row, Container } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import { H6, H5, LI, UL, P, Btn, Spinner, Breadcrumbs } from 'AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import { handleGetDetailMembership, tryParseJSON } from 'Component/Learning/Membership/MembershipsUtils';
import { fetchMemberships } from 'Features/Learning/Memberships/Utils/MembershipUtils';
import { setDetail } from 'Features/Learning/Memberships/membershipSlice';
import GenerateUniqueContain from 'Component/Learning/Common/GenerateUnique';
import CurrencyFormatter from 'Component/Learning/Common/GenerateContent/CurrencyFormatter';
import RawHTMLComponent from 'Component/Learning/Common/RawHTML';
import Moment from 'moment';
import 'moment/locale/id';
import GuidelineMembership from 'Component/Learning/Membership/GuidelineMembership/GuidelineMembership';
import { fetchGuidelines } from 'Features/Learning/Guidelines/Utils/GuidelineUtils';

const MembershipGuideline = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const filter = useSelector(state => state.Membership.filters);
  const [refetch, setRefatch] = useState(false);

  useEffect(() => {
    const newFilters = {
      ...filter,
      "filter[id]": id,
      "page": 1,
      "include": "mainProgram,tryouts.category"
    };
    dispatch(fetchMemberships(newFilters))
      .then((response) => {
        // Kode yang akan dijalankan setelah fetch sukses
        handleGetDetailMembership(dispatch, response.payload.data[0], setDetail)
        // Kode lain yang perlu dijalankan setelah fetch sukses
        dispatch(fetchGuidelines(id))
      })
      .catch((error) => {
        // Tangani error jika fetch gagal
        console.error('Error during fetchMemberships:', error);
      });
  }, [id, refetch]);

  const detail = useSelector(state => state.Membership.detail);
  const isLoading = useSelector(state => state.Membership.isLoading);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <>
      <Breadcrumbs mainTitle="Membership Guideline" parent="Membership" title="Membership Guideline" />
      <Container fluid={true}>
        <Row className="product-page-main p-0">
          {
            isLoading &&
            <Col lg="12">
              <div className="loader-box">
                <Spinner attrSpinner={{ className: 'loader-30' }} />
              </div>
              <H6 attrH6={{ className: 'sub-title mb-3 text-center' }}>{'Data Loading...'}</H6>
            </Col>
          }
          <Col sm="12" xl="12" lg="12" className="xl-100 box-col-12 order-1">
            <Card className="social-widget-card">
              <CardHeader>
                <Col>
                  <Row>
                    <Col>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{detail.title || 'Title Membership'}</H5>
                    </Col>
                    <Col className='text-end'>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>ID Membership : {GenerateUniqueContain('MBS', detail.id, 5) || 'ID Membership'}</H5>
                    </Col>
                  </Row>
                </Col>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Col>
                      <Row>
                        <Col>
                          <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Harga'}</H5>
                          <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}><CurrencyFormatter amount={detail.price} /></H6>
                        </Col>
                        <Col>
                          <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Harga Coret'}</H5>
                          <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>{detail.gimmick_price ? <CurrencyFormatter amount={detail.gimmick_price} /> : '-'}</H6>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Masa Aktif Membership'}</H5>
                      <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>{detail.duration_days} Hari</H6>
                    </Col>
                    <Col>
                      <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Jenis Membership'}</H5>
                      <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>
                        {detail.is_online === true ? 'Online ' : 'Offline '}
                        {detail.is_to_only === true ? '(Tryout Only)' : ''}
                      </H6>
                    </Col>
                    <Col>
                      <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Garansi Membership'}</H5>
                      <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>
                        {detail.is_guaranteed === true ? 'Tersedia ' : 'Tidak Tersedia '}
                      </H6>
                    </Col>
                    <Col>
                      <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Bisa menggunakan Referral'}</H5>
                      <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>
                        {detail.is_blacklist_referral === true ? 'Bisa' : 'Tidak'}
                      </H6>
                    </Col>
                    <Col>
                      <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Apakah terdapat guideline'}</H5>
                      <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>
                        {detail?.is_guideline === true ? 'Ada' : 'Tidak'}
                      </H6>
                    </Col>
                    {
                      detail?.is_guideline === true &&
                      <Col>
                        <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Deskripsi Guide Line'}</H5>
                        <P attrP={{ className: 'font-roboto mb-0' }}>
                          {detail?.guideline_description || '-'}
                        </P>
                      </Col>
                    }
                    <Col>
                      <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mt-2' }}>{'Kategori Program Utama'}</H5>
                      <H6 attrH6={{ className: 'font-roboto mb-0 font-primary' }}>{detail.main_program ? detail.main_program.title : '-'}</H6>
                    </Col>
                  </Col>
                  <Col>
                    <H5 attrH5={{ className: 'counter mt-4 font-roboto font-primary mb-2' }}>{'Fasilitas Membership'}</H5>
                    {detail.points && detail.points.length > 0 ? (
                      <UL attrUl={{ className: 'list-unstyled mt-2 mb-0' }}>
                        {detail.points.map((item, index) => {
                          const isDataJSON = tryParseJSON(item); // Panggil fungsi isDataJSON di sini
                          const pointName = isDataJSON ? JSON.parse(item).name : item;
                          const pointStatus = isDataJSON ? JSON.parse(item).status : true;

                          return (
                            <LI key={`points-${index}`} attrLI={{ className: 'd-flex align-items-center mb-2' }}>
                              <i className={`fa fa-${pointStatus ? 'check' : 'times'} fa-lg me-2`} style={{ color: pointStatus ? 'green' : 'red' }}></i>
                              {/* <b>{pointName}</b> */}
                              <RawHTMLComponent htmlContent={pointName} padding={false} />
                            </LI>
                          )
                        })}
                      </UL>
                    ) : (
                      <P attrP={{ className: 'mb-0 font-roboto' }}><b>Tidak ada fasilitas.</b></P>
                    )}
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Row>
                  <Col>
                    <P attrP={{ className: 'font-roboto' }}>Created at: {Moment(detail.created_at).format('dddd, D MMMM YYYY')} - {Moment(detail.created_at).format('HH:mm:ss')} WIB</P>
                    <P attrP={{ className: 'font-roboto' }}><b>Updated at: {Moment(detail.updated_at).format('dddd, D MMMM YYYY')} - {Moment(detail.updated_at).format('HH:mm:ss')} WIB</b></P>
                  </Col>
                  <Col className='text-end'>
                    <Link to={`${process.env.PUBLIC_URL}/membership/membership-list`}>
                      <Btn attrBtn={{ color: 'warning', className: 'btn btn-primary m-r-10' }}>
                        <i className="fa fa-chevron-circle-left fa-lg me-2"></i>Back
                      </Btn>
                    </Link>
                    <Link to={`${process.env.PUBLIC_URL}/membership/guideline-add/${detail.id}`}>
                      <Btn attrBtn={{ color: 'primary', className: 'btn btn-primary m-r-10' }}>
                        <i className="icofont icofont-sub-listing fa-lg me-2"></i>Tambah Guideline
                      </Btn>
                    </Link>
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
          <GuidelineMembership
            membershipId={id}
            detail={detail}
            dispatch={dispatch}
            setRefatch={setRefatch}
          />
        </Row>
      </Container>
    </>
  );
};
export default MembershipGuideline;